module.exports = __webpack_public_path__ + "static/img/100_own_building_plant2.ad31cb7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/100_own_building_plant2.jpg
// module id = nnkS
// module chunks = 1